<template>
  <b-form-group
    id="input-group-1"
    label="Patente"
    label-for="formrow-inputState"
  >
    <b-row>
      <b-col sm="12"
             md="11"
             lg="11">
        <b-form-select
          id="formrow-inputState"
          value-field="patent"
          :options="patents"
          type="text"
          v-model="patent"
          @change="$emit('change', {});"
        ></b-form-select>
      </b-col>
      <b-col lg="1" class="icon">
        <b-spinner v-if="isBusy" small class="align-middle"></b-spinner>
        <i v-else class="hand bx bx-x font-size-24" @click="clear" />
      </b-col>
    </b-row>
  </b-form-group>
</template>

<script>
import PatentsService from "./patentsService";

export default {
  props: {
    value: String,
    patentView: String
  },
  data: function () {
    return {
      patents: [],
      patent: this.value,
      patentMethodName: this.patentView,
      isBusy: false
    }
  },
  mounted () {
    this.getPatents();
  },
  methods: {
    getPatents () {
      this.isBusy = true
      let patentsRequest;
      patentsRequest = PatentsService[this.patentMethodName](this.$store.state.rutEmpresa.cuentaSeleccionada.value)
      patentsRequest.then(patents => {
        this.patents = patents
        this.isBusy = false
      })
        .catch(err => {
          console.log(err)
          this.isBusy = false
        });
    },
    clear () {
      this.patents = []
      this.patent = ''
      this.getPatents()
      this.$emit("change", {});
    }
  },
  patent: {
    selectedRut (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('input', newVal);
      }
    }
  },
  watch: {
    patent (newVal) {
      this.$emit("input", newVal);
      this.$emit("change", {});
    },
  }
}
</script>

<style>
.icon {
  margin-left: -25px;
  margin-top: 5px;
}
</style>
